import { render, staticRenderFns } from "./tabCarousel.vue?vue&type=template&id=e5fe5f24&scoped=true&"
import script from "./tabCarousel.vue?vue&type=script&lang=js&"
export * from "./tabCarousel.vue?vue&type=script&lang=js&"
import style0 from "./tabCarousel.vue?vue&type=style&index=0&id=e5fe5f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe5f24",
  null
  
)

export default component.exports